import {INIT_URL,
    GET_USER,
    UPDATE_USER,
    UPDATE_USER_SETTING,
    SET_USERS_FILTER,
    SET_SMSS_FILTER,
    GET_USER_BUDGET,
    GET_USER_BUDGET_WORK_DAYS,
    GET_USER_BUDGET_UTPRIS,
    GET_USER_BUDGET_ANTAL,
    UPDATE_USER_BUDGET,
    GET_USER_BUDGET_ACTIVITIES,
    UPDATE_USER_ACTIVITIES,
    GET_USER_INTEGRATION,
    UPDATE_USER_INTEGRATION,
    GET_USER_BUDGET_MOTE,GET_USER_UPDATE_BUDGET_ORDERVARDER,
    GET_USER_UPDATE_BUDGET_MOTE,GET_USER_BUDGET_ORDERVARDE,
    SET_ZERO_USER,
    
    ON_START_CONNENCT_OUTLOOK,ON_CONNENCT_OUTLOOK,ON_ERROR_CONNENCT_OUTLOOK,
    ON_START_GET_USER_KUND_TABLE_COLUMN,
    ON_ERROR_GET_USER_KUND_TABLE_COLUMN,
    ON_GET_USER_KUND_TABLE_COLUMN,
    ON_START_UPDATE_USER_KUND_TABLE_COLUMN,
    ON_ERROR_UPDATE_USER_KUND_TABLE_COLUMN,
    ON_UPDATE_USER_KUND_TABLE_COLUMN,

    ON_START_GET_USER_OFFERT_ART_TABLE_COLUMN,
    ON_ERROR_GET_USER_OFFERT_ART_TABLE_COLUMN,
    ON_GET_USER_OFFERT_ART_TABLE_COLUMN,
    ON_START_UPDATE_USER_OFFERT_ART_TABLE_COLUMN,
    ON_ERROR_UPDATE_USER_OFFERT_ART_TABLE_COLUMN,
    ON_UPDATE_USER_OFFERT_ART_TABLE_COLUMN,

    ON_CLOSE_USER_TOASTR,
    ON_GET_MY_DRIVES,
    ON_ERROR_GET_MY_DRIVES,
    ON_START_GET_MY_DRIVES,
    ON_OPEN_FILTER_USERS,ON_ClOSE_FILTER_USERS,
    ON_OPEN_FILTER_SMSS,ON_ClOSE_FILTER_SMSS
  } 
from "../constants/ActionTypes";
import {isEmpty,isUndefined} from 'lodash';
  import { translate } from "../util/intlHelper";

const INIT_STATE = {
    token: JSON.parse(localStorage.getItem('token')),
    user:'',    
    budget:{},
    budgetWorkDays:{},
    budgetUtpris:{},
    budgetAntal:{},
    Motebudget:{},
    budget_activities:{},
    budget_Ordervarde:{},
    integration:'',
    offertArtTableColumns:{},
    kundTableColumns: {},
    ResponseUserMsg:{},
    MyOneDrives: [],
		OneDriveFoldersLoading: false,
    SharedOneDrives: [],
    UserFilterOption:isUndefined(localStorage.UserFilter)?[]:JSON.parse(localStorage.UserFilter), 
    SMSFilterOption:isUndefined(localStorage.SMSFilter)?[]:JSON.parse(localStorage.SMSFilter), 
    FilterUsersPopup: false,
    FilterSMSsPopup: false,
  };

export default (state = INIT_STATE, action) => {
    switch (action.type) {
      case SET_ZERO_USER:{
        return INIT_STATE;
      }
      
        case GET_USER: {
            console.log(action)
            return {
              ...state,
              user:action.payload,
              success:!isEmpty(action.payload) 
            };
          }
        case UPDATE_USER: {
            console.log(action)
            return {
              ...state,
              user:action.payload,
              success:!isEmpty(action.payload) 
            };
          }
        case UPDATE_USER_SETTING: {
            console.log(action)
            return {
              ...state,
              user:action.payload,
              success:!isEmpty(action.payload) 
            };
          }
        
        
        case GET_USER_BUDGET: {
            console.log(action)
            return {
              ...state,
              budget:action.payload,
              success:!isEmpty(action.payload) 
            };
          }
        case GET_USER_BUDGET_WORK_DAYS: {
            console.log(action)
            return {
              ...state,
              budgetWorkDays:action.payload,
              success:!isEmpty(action.payload) 
            };
          }
        case GET_USER_BUDGET_UTPRIS: {
            console.log(action)
            return {
              ...state,
              budgetUtpris:action.payload,
              success:!isEmpty(action.payload) 
            };
          }
        case GET_USER_BUDGET_ANTAL: {
            console.log(action)
            return {
              ...state,
              budgetAntal:action.payload,
              success:!isEmpty(action.payload) 
            };
          }
        case UPDATE_USER_BUDGET: {
            console.log(action)
            return {
              ...state,
              budget:action.payload,
              success:!isEmpty(action.payload) 
            };
          }
        case GET_USER_BUDGET_ACTIVITIES: {
            console.log(action)
            return {
              ...state,
              budget_activities:action.payload,
              success:!isEmpty(action.payload) 
            };
          }
        case UPDATE_USER_ACTIVITIES: {
            console.log(action)
            return {
              ...state,
              budget_activities:action.payload,
              success:!isEmpty(action.payload) 
            };
          }
        case GET_USER_INTEGRATION: {
            console.log(action)
            return {
              ...state,
              integration:action.payload,
              success:!isEmpty(action.payload) 
            };
          }
        case UPDATE_USER_INTEGRATION: {
            console.log(action)
            return {
              ...state,
              integration:action.payload,
              success:!isEmpty(action.payload) 
            };
          }
          //,,,
          case ON_START_CONNENCT_OUTLOOK:{
            console.log("ON_START_CONNENCT_OUTLOOK",action)
            return {
                ...state,   
            }
        }
        case ON_CONNENCT_OUTLOOK:{
            console.log("ON_CONNENCT_OUTLOOK",action)
            return {
                ...state,
                integration:action.payload.integration,
                message:translate("Action.Account.Outlook")
            }
        }
        case ON_ERROR_CONNENCT_OUTLOOK:{
            console.log("ON_ERROR_CONNENCT_OUTLOOK",action)
            return {
                ...state,
                message:translate("Error.Account.Outlook")
            }
        }
        //GET_USER_BUDGET_MOTE
        case GET_USER_BUDGET_MOTE: {
          console.log("GET_USER_BUDGET_MOTE",action)
          return {
            ...state,
            Motebudget:action.payload,
            success:false
          };
        }
        case GET_USER_UPDATE_BUDGET_MOTE: {
          console.log("GET_USER_UPDATE_BUDGET_MOTE",action)
          return {
            ...state,
            Motebudget:action.payload,
            success:true 
          };
        }
        case GET_USER_UPDATE_BUDGET_ORDERVARDER: {
          console.log("GET_USER_UPDATE_BUDGET_ORDERVARDER",action)
          return {
            ...state,
            budget_Ordervarde:action.payload,
            success:true 
          };
        }
        case GET_USER_BUDGET_ORDERVARDE: {
          console.log("GET_USER_BUDGET_ORDERVARDE",action)
          return {
            ...state,
            budget_Ordervarde:action.payload,
            success:true 
          };
        }
        case ON_START_GET_USER_KUND_TABLE_COLUMN: {
          console.log("ON_START_GET_USER_KUND_TABLE_COLUMN", action.payload)
          return {
            ...state,
            ResponseUserMsg:{}
          }
        }
        case ON_ERROR_GET_USER_KUND_TABLE_COLUMN: {
          console.log("ON_ERROR_GET_USER_KUND_TABLE_COLUMN", action.payload)
          return {
            ...state,
            ResponseUserMsg:{}
          }
        }
        case ON_GET_USER_KUND_TABLE_COLUMN: {
          console.log("ON_GET_USER_KUND_TABLE_COLUMN", action.payload)
          return {
            ...state,
            kundTableColumns: action.payload.kundTableColumns,
            ResponseUserMsg:{}
          }
        }
        case ON_START_UPDATE_USER_KUND_TABLE_COLUMN: {
          console.log("ON_START_UPDATE_USER_KUND_TABLE_COLUMN", action.payload)
          return {
            ...state,
            ResponseUserMsg:{}
          }  
        }
        case ON_ERROR_UPDATE_USER_KUND_TABLE_COLUMN: {
          console.log("ON_ERROR_UPDATE_USER_KUND_TABLE_COLUMN", action.payload)
          return {
            ...state,
            ResponseUserMsg:{msg:translate("Error.Account.Client.Table.update"),type:"error",loading:false}
          }
        }
        case ON_UPDATE_USER_KUND_TABLE_COLUMN: {
          console.log("ON_UPDATE_USER_KUND_TABLE_COLUMN", action.payload)
          return {
            ...state,
            kundTableColumns: action.payload.kundTableColumns,
            ResponseUserMsg:{msg:translate("Action.Account.Client.Table.update"),type:"success",loading:false}
          }
        }
        case ON_START_GET_USER_OFFERT_ART_TABLE_COLUMN: {
          console.log("ON_START_GET_USER_OFFERT_ART_TABLE_COLUMN", action.payload)
          return {
            ...state,
            ResponseUserMsg:{}
          }
        }
        case ON_ERROR_GET_USER_OFFERT_ART_TABLE_COLUMN: {
          console.log("ON_ERROR_GET_USER_OFFERT_ART_TABLE_COLUMN", action.payload)
          return {
            ...state,
            ResponseUserMsg:{}
          }
        }
        case ON_GET_USER_OFFERT_ART_TABLE_COLUMN: {
          console.log("ON_GET_USER_OFFERT_ART_TABLE_COLUMN", action.payload)
          return {
            ...state,
            offertArtTableColumns: action.payload.offertArtTableColumns,
            ResponseUserMsg:{}
          }
        }
        case ON_START_UPDATE_USER_OFFERT_ART_TABLE_COLUMN: {
          console.log("ON_START_UPDATE_USER_OFFERT_ART_TABLE_COLUMN", action.payload)
          return {
            ...state,
            ResponseUserMsg:{}
          }  
        }
        case ON_ERROR_UPDATE_USER_OFFERT_ART_TABLE_COLUMN: {
          console.log("ON_ERROR_UPDATE_USER_OFFERT_ART_TABLE_COLUMN", action.payload)
          return {
            ...state,
            ResponseUserMsg:{msg:translate("Error.Account.Offett.Table.update"),type:"error",loading:false}
          }
        }
        case ON_UPDATE_USER_OFFERT_ART_TABLE_COLUMN: {
          console.log("ON_UPDATE_USER_OFFERT_ART_TABLE_COLUMN", action.payload)
          return {
            ...state,
            offertArtTableColumns: action.payload.offertArtTableColumns,
            ResponseUserMsg:{msg:translate("Action.Account.Offett.Table.update"),type:"success",loading:false}
          }
        }
        case ON_CLOSE_USER_TOASTR: {
          console.log("ON_CLOSE_USER_TOASTR", action.payload)
          return {
            ...state,
            ResponseUserMsg:{}
          }
        }
        // sharedWithMe, myDrives
        case ON_GET_MY_DRIVES: {
          console.log("ON_GET_MY_DRIVES", action.payload)
          return {
            ...state,
						OneDriveFoldersLoading: false,
            MyOneDrives: action.payload.myDrives,
            SharedOneDrives: action.payload.sharedWithMe,
            ResponseUserMsg:{}
          }
        }
        case ON_ERROR_GET_MY_DRIVES: {
          console.log("ON_ERROR_GET_MY_DRIVES", action.payload)
          return {
            ...state,
						OneDriveFoldersLoading: false,
            MyOneDrives: [],
            SharedOneDrives: [],
            ResponseUserMsg:{msg:action.payload,type:translate("Error.Account.OneDrive.get"),loading:false}
          }
        }
        case ON_START_GET_MY_DRIVES: {
          console.log("ON_START_GET_MY_DRIVES", action.payload)
          return {
            ...state,
						OneDriveFoldersLoading: true,
            MyOneDrives: [],
            SharedOneDrives: [],
            ResponseUserMsg:{}
          }
        }
        case ON_OPEN_FILTER_USERS: {
          console.log("ON_OPEN_FILTER_USERS", action.payload)
          return {
            ...state, 
            FilterUsersPopup:true,
            UserFilterOption:isUndefined(localStorage.UserFilter)?[]:JSON.parse(localStorage.UserFilter),
          }
        }
        case ON_ClOSE_FILTER_USERS: {
          console.log("ON_ClOSE_FILTER_USERS", action.payload)
          return {...state, FilterUsersPopup:false}
        }
        case ON_OPEN_FILTER_SMSS: {
          console.log("ON_OPEN_FILTER_USERS", action.payload)
          return {
            ...state, 
            FilterSMSsPopup:true,
            SMSFilterOption:isUndefined(localStorage.SMSFilter)?[]:JSON.parse(localStorage.SMSFilter),
          }
        }
        case ON_ClOSE_FILTER_SMSS: {
          console.log("ON_ClOSE_FILTER_USERS", action.payload)
          return {...state, FilterSMSsPopup:false}
        }
        
        //SET_USERS_FILTER
        case SET_USERS_FILTER: {
          console.log("SET_USERS_FILTER", action.payload)
          localStorage.removeItem("UserFilter");
          localStorage.setItem("UserFilter", JSON.stringify(action.payload));
          return {...state, UserFilterOption: action.payload}
        }
        case SET_SMSS_FILTER: {
          console.log("SET_SMSS_FILTER", action.payload)
          localStorage.removeItem("SMSFilter");
          localStorage.setItem("SMSFilter", JSON.stringify(action.payload));
          return {...state, SMSFilterOption: action.payload}
        }
        //
          default:
            return state;
        
    }
}